module.exports = __webpack_public_path__ + "static/media/default_field_image.944ea749.png";